import { Button } from '@voll-intelligence/ui-kit/ui/button';

import type { GenUiDispatch } from '../../../shared/ui/action.js';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import type { WalletLinkBlock } from '@voll-intelligence/genui-contract';

/**
 * O atalho para a Carteira do app (#6278): o título da tela e o botão que a abre
 * (`open-wallet`). `readOnly` (thread do operador, conversa encerrada) mostra só o título.
 */
export function WalletLinkCard({
  screen,
  readOnly = false,
  dispatch,
}: Readonly<{ screen: WalletLinkBlock['screen']; readOnly?: boolean; dispatch: GenUiDispatch }>) {
  const { t } = useGenUiI18n();
  return (
    <div className="flex w-full items-center justify-between gap-3 rounded-md border border-border bg-card px-4 py-3 shadow-(--shadow-elevation)">
      <span className="text-ui min-w-0 text-foreground">{t(`walletLink.title.${screen}`)}</span>
      {!readOnly && (
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => {
            dispatch({ type: 'open-wallet', screen });
          }}
        >
          {t('walletLink.cta')}
        </Button>
      )}
    </div>
  );
}
